// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ktHS2{padding:0;margin:0}.VbjmV{position:relative;min-height:300px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DKakK{width:100%;height:292px;padding:32px 40px;border:1px solid #e2e2e2;margin:0 0 8px;background:#fff;border-radius:8px;box-shadow:0 2px 14px rgba(0,0,0,.06);font-size:16px;line-height:24px;text-align:center}@media screen and (min-width:768px){.DKakK{width:100%;height:300px;padding:32px;margin:0;font-size:18px;line-height:32px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "ktHS2",
	"content": "VbjmV",
	"notFound": "DKakK"
};
module.exports = ___CSS_LOADER_EXPORT___;
